/* Mooncorn "Kendi Kutunu Oluştur" — koleksiyonda çoklu seçim + toplu sepete ekleme.
 * Tema sözleşmeleri: Cart.addItems (tek POST, drawer güncelle+aç), theme:feedback:load,
 * customElements deseni (<product-quick-add> emsali: innerHTML re-render'da connectedCallback
 * yeniden-init). Seçim sessionStorage'da, KAMPANYA-kimlikli. Dinamik veriyle innerHTML YOK (XSS).
 * /cart/add.js ATOMİK DEĞİL → ekleme-sonrası /cart.js doğrulaması; seçim ancak doğrulanınca düşer.
 */
import { Cart } from '@troop-themes/main';

const STORE_KEY = 'mooncorn-box:v1';
const BODY_CLASS = 'is-box-building';
const NUDGE_KEY = 'mooncorn-box:v1:nudge';
const SLOT_INTRO_KEY = 'mooncorn-box:v1:slotintro';
const REDUCED_MOTION = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const MOBILE_MQ = '(max-width: 767px)';

/* ── depo (sekme-içi tek yazar → bellek önbelleği güvenli) ─────────────── */
let storeCache = null;
function readStore() {
  if (storeCache) return storeCache;
  try {
    const raw = sessionStorage.getItem(STORE_KEY);
    if (!raw) return (storeCache = { mode: false, items: [] });
    const data = JSON.parse(raw);
    // şema doğrulama + normalizasyon: bozuk c → 'global' (hayalet kalem önlenir), bozuk q → 1 (add.js'e taşmaz)
    const items = Array.isArray(data.items)
      ? data.items
          .filter((it) => it && Number.isInteger(Number(it.v)) && typeof it.h === 'string' && typeof it.t === 'string')
          .map((it) => ({
            v: Number(it.v),
            h: it.h,
            t: it.t,
            img: typeof it.img === 'string' ? it.img : '',
            u: typeof it.u === 'string' ? it.u : '',
            c: typeof it.c === 'string' && it.c ? it.c : 'global',
            p: Number(it.p) || 0,
            q: Number.isInteger(it.q) && it.q > 0 && it.q <= 12 ? it.q : 1,
          }))
      : [];
    return (storeCache = { mode: data.mode === true, items });
  } catch { return (storeCache = { mode: false, items: [] }); }
}
function writeStore(state) {
  storeCache = state;
  try { sessionStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch { /* private mode */ }
  window.dispatchEvent(new CustomEvent('box:changed', { detail: state }));
}
const BoxStore = {
  state: readStore,
  itemsFor(campaign) { return readStore().items.filter((it) => (it.c || 'global') === (campaign || 'global')); },
  has(v, campaign) { return this.itemsFor(campaign).some((it) => String(it.v) === String(v)); },
  add(item, max) {
    if (this.has(item.v, item.c)) return { ok: false, reason: 'dup' };
    if (this.itemsFor(item.c).length >= max) return { ok: false, reason: 'max' };
    const state = readStore();
    state.items.push(item);
    writeStore(state);
    return { ok: true };
  },
  remove(v, campaign) {
    const state = readStore();
    state.items = state.items.filter((it) => !(String(it.v) === String(v) && (it.c || 'global') === (campaign || 'global')));
    soldOut.delete(String(v));
    writeStore(state);
  },
  clearCampaign(campaign) {
    const state = readStore();
    state.items = state.items.filter((it) => {
      const inCampaign = (it.c || 'global') === (campaign || 'global');
      if (inCampaign) soldOut.delete(String(it.v));
      return !inCampaign;
    });
    writeStore(state);
  },
  setMode(on) {
    const state = readStore();
    state.mode = on === true;
    writeStore(state);
    applyBodyClass();
    if (!state.mode && state.items.length > 0) {
      feedback('box--kept'); // seçimler saklandı bildirimi (görsel)
      const bar = document.querySelector('box-bar');
      if (bar && bar.i18n && bar.i18n.kept) announce(bar.i18n.kept); // bar o an gizlendiği için SR köprüsünden
    }
    window.dispatchEvent(new CustomEvent('box:mode:changed', { detail: { mode: state.mode } }));
  },
};

/* ── yardımcılar ───────────────────────────────────────────────────────── */
const soldOut = new Set(); // seçimden SONRA tükenenler (ön-doğrulama işaretler/tazeler; otomatik silme YOK)
let inFlight = false;
let boxIdSig = null;
let boxIdVal = null;
function boxIdFor(items) {
  // seçim-seti başına sabit kimlik; reused=true → önceki (belirsiz sonuçlu) denemeden kalan id:
  // gönderen taraf POST ÖNCESİ sepette bu id'nin satırlarını yoklamalı (adet-katlama önlemi)
  const sig = items.map((it) => it.v).sort().join(',');
  const reused = sig === boxIdSig;
  if (!reused) {
    boxIdSig = sig;
    boxIdVal = 'kutu-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
  }
  return { id: boxIdVal, reused };
}
function routesRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
function applyBodyClass() {
  const mode = readStore().mode;
  document.body.classList.toggle(BODY_CLASS, mode);
  // mod kapalıyken bar ekran-dışı AMA DOM'da: inert ile odak+ekran-okuyucudan da çıkar
  // (CSS gecikmeli-visibility geçişi Chrome'da takılı kalabildiği için JS'ten deterministik)
  document.querySelectorAll('box-bar').forEach((b) => { b.inert = !mode; });
}
function interp(template, vars) {
  return String(template || '').replace(/\{\{\s*(\w+)\s*\}\}/g, (m, k) => (vars[k] != null ? String(vars[k]) : m));
}
function feedback(key) { window.dispatchEvent(new CustomEvent('theme:feedback:load', { detail: { async: key } })); }
/* SR duyuru köprüsü: mobilde tek status bölgesi kapalı (inert) akordiyonda kalabildiği ve
 * feedback-bar'da aria-live olmadığı için, her-zaman-görünür toggle şeridindeki sr-only
 * canlı bölgeye yazar. Aynı metnin peş peşe tekrarı duyurulmaz (sekme-dönüşü gürültü önlemi). */
function announce(msg) {
  const el = document.querySelector('[data-box-announce]');
  if (!el || !msg || el.textContent === msg) return;
  el.textContent = msg;
}
/* temanın kendi sepet-yenileme kancası (/cart/update.js ile section tazeler):
   addItems'sız güncellenen senaryolarda (probe-başarı / geri-alma) rozet+drawer bayat kalmasın */
function refreshCartUi() {
  try { window.dispatchEvent(new CustomEvent('theme:cart:refresh')); } catch { /* yoksay */ }
}
/* verilen satır anahtarlarını sepetten kaldırır (kısmi-ekleme geri-alma); ilk hatada fırlatır */
async function removeCartLines(keys) {
  for (const key of keys) {
    const r = await fetch(routesRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
    if (!r.ok) throw new Error(r.statusText);
  }
}
function formatMoney(cents) {
  const lang = document.documentElement.lang || 'tr';
  const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'TRY';
  try {
    // narrowSymbol: TR-dışı sayfa dilinde de 'TRY' kodu değil '₺' — temanın sunucu biçimiyle hizalı
    return new Intl.NumberFormat(lang, { style: 'currency', currency, currencyDisplay: 'narrowSymbol' }).format(cents / 100);
  } catch {
    try { return new Intl.NumberFormat(lang, { style: 'currency', currency }).format(cents / 100); }
    catch { return (cents / 100).toFixed(2); }
  }
}
function safeImgSrc(src) {
  if (!src) return '';
  try {
    const u = new URL(src, window.location.origin);
    if (u.protocol !== 'https:' && u.protocol !== 'http:') return '';
    if (u.host === window.location.host || u.hostname.endsWith('.shopify.com')) return u.href;
  } catch { /* geçersiz URL */ }
  return '';
}
function gridScope() { return document.querySelector('[data-body-grid]') || document; }
function syncAll() {
  storeCache = null; // bfcache dönüşü: depoyu diskten tazele
  applyBodyClass();
  // sync:true → kullanıcı eylemi DEĞİL; kalıcı (sticky) uyarılar bu senkronla silinmez
  window.dispatchEvent(new CustomEvent('box:changed', { detail: { ...readStore(), sync: true } }));
}

/* ── <box-toggle> — announcement şeridi ────────────────────────────────── */
class BoxToggle extends HTMLElement {
  connectedCallback() {
    this.inputEl = this.querySelector('input');
    this.countEl = this.querySelector('[data-box-toggle-count]');
    this.trackEl = this.querySelector('.box-toggle--track');
    this.campaign = this.dataset.campaign || 'global';
    // element-scoped listener'lar BİR KEZ bağlanır (reconnect'te çiftlenmesin); window'unkiler her connect'te
    if (!this._wired) {
      this._wired = true;
      this.onChange = () => BoxStore.setMode(this.inputEl.checked);
      this.onChanged = () => this.render();
      this.inputEl && this.inputEl.addEventListener('change', this.onChange);
    }
    window.addEventListener('box:changed', this.onChanged);
    window.addEventListener('box:mode:changed', this.onChanged);
    applyBodyClass();
    this.render();
    this.startRotator();
    this.scheduleNudge();
  }
  disconnectedCallback() {
    window.removeEventListener('box:changed', this.onChanged);
    window.removeEventListener('box:mode:changed', this.onChanged);
    this.rotTimer && clearInterval(this.rotTimer);
    this.rotTimer = null; // reconnect'te rotator yeniden başlayabilsin
    this.nudgeTimer && clearTimeout(this.nudgeTimer);
  }
  render() {
    const state = readStore();
    if (this.inputEl && this.inputEl.checked !== state.mode) this.inputEl.checked = state.mode;
    if (this.countEl) {
      const n = BoxStore.itemsFor(this.campaign).length; // bar sayacıyla AYNI gerçek (kampanya-bazlı)
      this.countEl.textContent = n > 0 ? '(' + n + ')' : '';
      this.countEl.hidden = n === 0;
    }
  }
  /* orta bölge: dönen bilgi metinleri — tema announcement varsayılanıyla hizalı 7sn;
     hover/focus'ta durur (WCAG 2.2.2); reduced-motion'da hiç dönmez; aria-live=off (dekoratif) */
  startRotator() {
    this.msgs = [...this.querySelectorAll('.box-announce--message')];
    if (this.msgs.length < 2 || REDUCED_MOTION) return;
    // reconnect: data-active hangi mesajda kaldıysa oradan sür (attribute durumu DOM'da yaşıyor)
    this.msgIdx = Math.max(0, this.msgs.findIndex((m) => m.hasAttribute('data-active')));
    if (!this._rotWired) {
      this._rotWired = true; // hover/focus listener'ları reconnect'te çiftlenmesin
      this._rotStart = () => {
        if (this.rotTimer || !this.isConnected) return;
        this.rotTimer = setInterval(() => {
          if (document.visibilityState !== 'visible') return;
          this.msgs[this.msgIdx].removeAttribute('data-active');
          this.msgs[this.msgIdx].setAttribute('aria-hidden', 'true');
          this.msgIdx = (this.msgIdx + 1) % this.msgs.length;
          this.msgs[this.msgIdx].setAttribute('data-active', '');
          this.msgs[this.msgIdx].removeAttribute('aria-hidden');
        }, 7000);
      };
      this._rotStop = () => { this.rotTimer && clearInterval(this.rotTimer); this.rotTimer = null; };
      this.addEventListener('mouseenter', this._rotStop);
      this.addEventListener('mouseleave', this._rotStart);
      this.addEventListener('focusin', this._rotStop);
      this.addEventListener('focusout', this._rotStart);
    }
    this._rotStart();
  }
  /* keşif: oturumda bir kez, mod kapalıyken knob'a küçük dürtme */
  scheduleNudge() {
    if (REDUCED_MOTION) return;
    let seen = null;
    try { seen = sessionStorage.getItem(NUDGE_KEY); } catch { seen = '1'; }
    if (seen) return;
    this.nudgeTimer = setTimeout(() => {
      if (readStore().mode || !this.trackEl) return;
      this.trackEl.setAttribute('data-nudge', '');
      setTimeout(() => this.trackEl.removeAttribute('data-nudge'), 2000);
      try { sessionStorage.setItem(NUDGE_KEY, '1'); } catch { /* yok say */ }
    }, 1500);
  }
}

/* ── <box-checkbox> — kart tiki ────────────────────────────────────────── */
class BoxCheckbox extends HTMLElement {
  connectedCallback() {
    this.inputEl = this.querySelector('input');
    if (!this.inputEl) return;
    // OOS/facet innerHTML re-render'ı sonrası bedava yeniden-init (kampanya-bazlı durum)
    this.inputEl.checked = BoxStore.has(this.dataset.variantId, this.dataset.campaign);
    this.onChange = () => this.handleChange();
    this.inputEl.addEventListener('change', this.onChange);
  }
  disconnectedCallback() { this.inputEl && this.inputEl.removeEventListener('change', this.onChange); }
  handleChange() {
    if (inFlight) { this.inputEl.checked = !this.inputEl.checked; return; } // gönderim sürerken seçim değişmez
    const bar = document.querySelector('box-bar');
    const max = bar ? parseInt(bar.dataset.max, 10) || 5 : 5;
    if (this.inputEl.checked) {
      const res = BoxStore.add({
        v: Number(this.dataset.variantId),
        h: this.dataset.handle || '',
        t: this.dataset.title || '',
        img: this.dataset.image || '',
        u: this.dataset.url || '',
        c: this.dataset.campaign || 'global',
        p: Number(this.dataset.price) || 0,
        q: 1,
      }, max);
      if (!res.ok) {
        this.inputEl.checked = false;
        if (res.reason === 'max') {
          this.setAttribute('data-shake', '');
          setTimeout(() => this.removeAttribute('data-shake'), 400);
          window.dispatchEvent(new CustomEvent('box:limit', { detail: { campaign: this.dataset.campaign } }));
        }
      }
    } else {
      BoxStore.remove(this.dataset.variantId, this.dataset.campaign);
    }
  }
}

/* ── <box-bar> — sabit alt bar ─────────────────────────────────────────── */
class BoxBar extends HTMLElement {
  connectedCallback() {
    try { this.i18n = JSON.parse(this.querySelector('[data-box-i18n]').textContent); } catch { this.i18n = {}; }
    this.campaign = this.dataset.campaign || 'global';
    this.min = parseInt(this.dataset.min, 10) || 1;
    this.max = parseInt(this.dataset.max, 10) || 5;
    this.freeCount = parseInt(this.dataset.freeCount, 10) || 0;
    this.slotWraps = this.querySelectorAll('[data-box-slots]');
    this.counterEls = this.querySelectorAll('[data-box-counter]');
    this.statusEls = this.querySelectorAll('[data-box-status]'); // masaüstü + mobil — İKİSİ de güncellenir
    this.noteEls = this.querySelectorAll('[data-box-note]');
    this.ctaEls = this.querySelectorAll('[data-box-cta]');
    this.clearEls = this.querySelectorAll('[data-box-clear]');
    this.triggerEl = this.querySelector('[data-box-mobile-trigger]');
    this.mobileContent = this.querySelector('.box-bar--mobile-content');
    if (this.mobileContent) this.mobileContent.inert = true; // kapalı akordiyon odak/SR'dan da kapalı

    this.prevCount = this.items().length;
    this.prevCtaOff = null;
    this.stickyMsg = null;
    this.postSuccess = false;
    this.userToggledAccordion = false;

    if (!this._wired) {
      this._wired = true; // element-scoped click listener'lar reconnect'te çiftlenmesin (çift submit/çift clear önlemi)
      this.onChanged = (e) => {
        const n = this.items().length;
        if (n > 0) this.postSuccess = false;
        // kalıcı mesaj yalnız KULLANICI eyleminde düşer (sekme-dönüşü senkronu silmesin)
        if (!(e && e.detail && e.detail.sync)) this.stickyMsg = null;
        this.render();
      };
      this.onLimit = () => this.showTransient(interp(this.i18n.full, { max: this.max }), true);
      this.ctaEls.forEach((b) => b.addEventListener('click', () => this.submit(b)));
      this.clearEls.forEach((b) => b.addEventListener('click', () => this.handleClear(b)));
      this.triggerEl && this.triggerEl.addEventListener('click', () => {
        this.userToggledAccordion = true;
        this.setExpanded(!this.classList.contains('expanded'));
      });
    }
    window.addEventListener('box:changed', this.onChanged);
    window.addEventListener('box:limit', this.onLimit);
    applyBodyClass();
    this.render();
  }
  disconnectedCallback() {
    window.removeEventListener('box:changed', this.onChanged);
    window.removeEventListener('box:limit', this.onLimit);
    clearTimeout(this.transientTimer);
    clearTimeout(this.introTimer);
    clearTimeout(this.clearTimer);
  }

  items() { return BoxStore.itemsFor(this.campaign); }

  /* durum metni: görsel bölgelere yaz + mobilde SR köprüsüne duyur
     (mobil status kapalı akordiyonda inert kalabilir; masaüstü bölge kendi aria-live'ıyla duyurur) */
  setStatusText(msg) {
    this.statusEls.forEach((el) => { el.textContent = msg; });
    // mobil + akordiyon KAPALIYKEN SR köprüsünden duyur (açıkken görünür aria-live bölge zaten duyurur → çift okuma olmasın)
    if (msg && window.matchMedia(MOBILE_MQ).matches && !this.classList.contains('expanded')) announce(msg);
  }

  setExpanded(open) {
    this.classList.toggle('expanded', open);
    this.triggerEl && this.triggerEl.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (this.mobileContent) this.mobileContent.inert = !open;
  }

  /* "5 al 3 öde" tarzı kampanyada kazanç: en ucuz freeCount ürün bedava */
  savings(items) {
    if (this.freeCount < 1 || items.length < this.max) return null;
    const prices = items.map((it) => Number(it.p) || 0);
    if (prices.some((p) => p <= 0)) return null;
    prices.sort((a, b) => a - b);
    return prices.slice(0, this.freeCount).reduce((a, b) => a + b, 0);
  }

  render() {
    const items = this.items();
    const others = readStore().items.length - items.length;
    const anySold = items.some((it) => soldOut.has(String(it.v)));
    const grew = items.length > this.prevCount;

    this.slotWraps.forEach((wrap) => this.renderSlots(wrap, items, grew));
    this.counterEls.forEach((el) => {
      el.textContent = items.length + '/' + this.max;
      if (grew && !REDUCED_MOTION) {
        el.setAttribute('data-bump', '');
        setTimeout(() => el.removeAttribute('data-bump'), 350);
      }
    });

    // durum satırı önceliği: sticky > tükendi > başarı-sonrası > boş > min-altı > kalan > HAZIR
    if (!this.transient) {
      let msg = '';
      if (this.stickyMsg) msg = this.stickyMsg;
      else if (anySold) msg = this.i18n.error_stock || '';
      else if (items.length === 0) msg = this.postSuccess ? (this.i18n.success_next || '') : (this.i18n.empty_state || '');
      else if (items.length < this.min) {
        msg = (this.min === this.max)
          ? interp(this.i18n.exact_hint, { max: this.max })
          : interp(this.i18n.min_hint, { min: this.min });
      } else if (items.length < this.max) {
        const remaining = this.max - items.length;
        msg = remaining === 1 ? (this.i18n.remaining_one || '') : interp(this.i18n.remaining_other, { remaining });
      } else {
        const save = this.savings(items);
        msg = save
          ? interp(this.i18n.ready_saving, { saving: formatMoney(save) })
          : (this.i18n.ready_hint || interp(this.i18n.counter, { count: items.length, max: this.max }));
      }
      this.setStatusText(msg);
    }
    this.noteEls.forEach((el) => {
      el.hidden = others <= 0;
      if (others > 0) el.textContent = interp(this.i18n.other_box_note, { count: others });
    });

    const ctaOff = inFlight || anySold || items.length < this.min || items.length > this.max;
    this.ctaEls.forEach((b) => { b.disabled = ctaOff; });
    // 5/5 dönüşüm anı: CTA aktifleşince tek seferlik bronz halka
    if (this.prevCtaOff === true && ctaOff === false && !REDUCED_MOTION) {
      this.ctaEls.forEach((b) => {
        b.classList.add('box-bar--cta-ready');
        setTimeout(() => b.classList.remove('box-bar--cta-ready'), 1600);
      });
    }
    this.prevCtaOff = ctaOff;

    // mobil keşif: ilk 0→1 seçimde akordiyonu kısa süre otomatik aç (oturumda bir kez)
    if (grew && this.prevCount === 0 && window.matchMedia(MOBILE_MQ).matches) {
      let intro = null;
      try { intro = sessionStorage.getItem(SLOT_INTRO_KEY); } catch { intro = '1'; }
      if (!intro) {
        try { sessionStorage.setItem(SLOT_INTRO_KEY, '1'); } catch { /* yok say */ }
        this.setExpanded(true);
        if (!REDUCED_MOTION) {
          this.introTimer = setTimeout(() => {
            // odak içerideyse kapatma: setExpanded(false)→inert odağı body'ye düşürürdü
            const focusInside = this.mobileContent && this.mobileContent.contains(document.activeElement);
            if (!this.userToggledAccordion && !focusInside) this.setExpanded(false);
          }, 2400);
        }
      }
    }
    this.prevCount = items.length;

    // çift yönlü senkron: griddeki tikler kampanya-bazlı depoya eşitlenir
    const inStore = new Set(items.map((it) => String(it.v)));
    gridScope().querySelectorAll('box-checkbox input').forEach((input) => {
      const host = input.closest('box-checkbox');
      if ((host.dataset.campaign || 'global') !== this.campaign) return;
      const v = String(host.dataset.variantId);
      if (input.checked !== inStore.has(v)) input.checked = inStore.has(v);
    });
  }

  renderSlots(wrap, items, grew) {
    wrap.textContent = '';
    const count = Math.max(this.max, items.length); // taşan seçim asla gizlenmez
    for (let i = 0; i < count; i++) {
      const item = items[i];
      const slot = document.createElement('div');
      slot.setAttribute('role', 'listitem');
      if (!item) {
        slot.className = 'box-bar--slot empty';
        slot.setAttribute('aria-hidden', 'true');
        wrap.appendChild(slot);
        continue;
      }
      const isSold = soldOut.has(String(item.v));
      const isNew = grew && i === items.length - 1 && !REDUCED_MOTION;
      slot.className = 'box-bar--slot filled' + (isSold ? ' soldout' : '') + (isNew ? ' is-new' : '');
      const src = safeImgSrc(item.img);
      if (src) {
        const img = document.createElement('img');
        img.src = src;
        img.alt = item.t;
        img.loading = 'lazy';
        slot.appendChild(img);
      }
      if (isSold) {
        const badge = document.createElement('span');
        badge.className = 'box-bar--slot-badge';
        badge.textContent = this.i18n.sold_out || '';
        slot.appendChild(badge);
      }
      const rm = document.createElement('button');
      rm.type = 'button';
      rm.className = 'box-bar--slot-remove';
      rm.setAttribute('aria-label', interp(this.i18n.remove_item, { title: item.t }));
      const x = document.createElement('span');
      x.setAttribute('aria-hidden', 'true');
      x.textContent = '×';
      rm.appendChild(x);
      rm.addEventListener('click', () => {
        if (inFlight) return; // uçuşta silme: POST'lanmış kalemler düşerse kısmi-telafi şaşar
        BoxStore.remove(item.v, this.campaign);
        // odak: sonraki dolu slot → Temizle → CTA (span'e düşmez)
        const next = wrap.querySelector('.box-bar--slot.filled .box-bar--slot-remove')
          || [...this.clearEls].find((b) => b.offsetParent) || this.ctaEls[0];
        next && next.focus && next.focus();
      });
      slot.appendChild(rm);
      wrap.appendChild(slot);
    }
  }

  /* iki-adımlı Temizle: ilk dokunuş "Emin misin?", 3sn içinde ikinci dokunuş siler */
  handleClear(button) {
    if (inFlight) return; // uçuşta temizleme kilitli (kart tikleriyle aynı kural)
    if (button.dataset.armed) {
      delete button.dataset.armed;
      clearTimeout(this.clearTimer);
      this.clearEls.forEach((b) => { b.textContent = this.i18n.clear_all || b.textContent; });
      BoxStore.clearCampaign(this.campaign);
      this.showTransient(this.i18n.cleared || '', false); // aria-live → SR de duyar
      feedback('box--cleared');
      return;
    }
    button.dataset.armed = '1';
    const original = button.textContent;
    button.textContent = this.i18n.clear_confirm || original;
    announce(this.i18n.clear_confirm || ''); // SR: buton-metni değişimi odak sabitken okunmaz — onay adımı duyurulsun
    this.clearTimer = setTimeout(() => {
      delete button.dataset.armed;
      button.textContent = original;
    }, 3000);
  }

  showTransient(msg, autoOpen) {
    this.transient = true;
    this.setStatusText(msg);
    if (autoOpen && window.matchMedia(MOBILE_MQ).matches && !this.classList.contains('expanded')) {
      this.setExpanded(true); // kapalı akordiyonda mesaj görünmez kalmasın
    }
    clearTimeout(this.transientTimer);
    this.transientTimer = setTimeout(() => { this.transient = false; this.render(); }, 3000);
  }

  setSticky(msg, autoOpen) {
    this.stickyMsg = msg; // bir sonraki kullanıcı eylemine dek kalır (drawer kapanınca da okunur)
    this.transient = false;
    this.setStatusText(msg);
    if (autoOpen && window.matchMedia(MOBILE_MQ).matches) this.setExpanded(true);
  }

  /* tükenme ön-doğrulaması: iyileştirmedir, kapı DEĞİL (timeout'ta atlanır); soldOut'u TAZELER */
  async preValidate(items) {
    const handles = [...new Set(items.map((it) => it.h).filter(Boolean))];
    if (!handles.length) return;
    const results = await Promise.race([
      Promise.allSettled(handles.map((h) => fetch(routesRoot() + 'products/' + encodeURIComponent(h) + '.js').then((r) => r.json()))),
      new Promise((res) => setTimeout(() => res(null), 3000)),
    ]);
    if (!results) return; // yavaş ağ: doğrulamayı atla
    const availability = new Map();
    results.forEach((r) => {
      if (r.status === 'fulfilled' && r.value && Array.isArray(r.value.variants)) {
        r.value.variants.forEach((v) => availability.set(Number(v.id), v.available));
      }
    });
    items.forEach((it) => {
      const avail = availability.get(Number(it.v));
      if (avail === false) soldOut.add(String(it.v));
      else if (avail === true) soldOut.delete(String(it.v)); // restok: kilidi çöz
    });
  }

  /* sepetteki bu kutunun satırlarını oku (satır sayısı + varyant seti + satır anahtarları) */
  async cartLines(kutuId) {
    const cart = await (await fetch(routesRoot() + 'cart.js')).json();
    const lines = (cart.items || []).filter((li) => li.properties && li.properties._kutu_id === kutuId);
    return {
      count: lines.length,
      variants: new Set(lines.map((li) => Number(li.variant_id))),
      keys: lines.map((li) => li.key),
    };
  }

  /* Belirsiz/yarım kalmış eklemenin TEK çözümleyicisi. prior = cartLines sonucu (null = sepet okunamadı).
     true döner = durum çözüldü (çağıran return etmeli); false = sepette iz yok, POST'a devam edilebilir. */
  async resolvePriorLines(items, prior) {
    if (prior === null) {
      // sepet durumu BİLİNMİYOR: aynı id ile POST adet katlayabilirdi → GÖNDERME; boxIdSig korunur,
      // sonraki denemede yine buradan (probe) geçilir
      this.showTransient(this.i18n.error || '', true);
      feedback('box--error');
      return true;
    }
    if (prior.count >= items.length) {
      // önceki deneme aslında TAM girmiş: başarı say + tema sepet UI'sını tazele (drawer/rozet bayat kalmasın)
      items.forEach((it) => BoxStore.remove(it.v, it.c));
      boxIdSig = null;
      this.postSuccess = true;
      refreshCartUi();
      this.showTransient(this.i18n.success || '', false);
      return true;
    }
    if (prior.count > 0) {
      // KISMİ girmiş: girenleri sepetten GERİ AL → seçim tam kalır, sonraki deneme taze kimlikle temiz gider
      try {
        await removeCartLines(prior.keys);
        boxIdSig = null;
        refreshCartUi();
        try { await this.preValidate(items); } catch { /* yoksay */ }
        if (items.some((it) => soldOut.has(String(it.v)))) {
          this.render(); // sebep: tükenen ürün — rozet + error_stock (kontrol kullanıcıda)
          if (window.matchMedia(MOBILE_MQ).matches) this.setExpanded(true);
        } else {
          this.showTransient(this.i18n.error || '', true);
          feedback('box--error');
        }
      } catch {
        // geri alma da düştü: girenleri seçimden düş + kalıcı uyarı (sepetini kontrol et)
        items.filter((it) => prior.variants.has(Number(it.v))).forEach((it) => BoxStore.remove(it.v, it.c));
        boxIdSig = null;
        this.setSticky(this.i18n.error_partial || this.i18n.error || '', true);
        feedback('box--partial');
      }
      return true;
    }
    return false; // count === 0 → sepette iz yok
  }

  async submit(button) {
    if (inFlight) return; // tek-uçuş kilidi
    const items = this.items();
    if (items.length < this.min || items.length > this.max) return;
    inFlight = true;
    const labelEl = button.querySelector('[data-box-cta-label]');
    const oldLabel = labelEl ? labelEl.textContent : '';
    button.setAttribute('aria-busy', 'true');
    if (labelEl) labelEl.textContent = this.i18n.adding || oldLabel;
    this.ctaEls.forEach((b) => { b.disabled = true; });
    let kutuId = null;
    try {
      await this.preValidate(items);
      if (items.some((it) => soldOut.has(String(it.v)))) {
        this.render(); // error_stock + Tükendi rozetleri (kontrol kullanıcıda)
        if (window.matchMedia(MOBILE_MQ).matches) this.setExpanded(true); // catch yoluyla simetri: mesaj kapalı akordiyonda kalmasın
        return;
      }
      const idInfo = boxIdFor(items);
      kutuId = idInfo.id;
      if (idInfo.reused) {
        // önceki BELİRSİZ sonuçlu denemeden kalan id: POST ÖNCESİ sepeti çözümle —
        // satırlar zaten girdiyse yeniden POST adetleri katlardı (aynı id+property → Shopify satırı birleştirir);
        // probe DÜŞERSE de POST edilmez (fail-open kapalı)
        let prior = null;
        try { prior = await this.cartLines(kutuId); } catch { prior = null; }
        if (await this.resolvePriorLines(items, prior)) return;
      }
      const payload = {
        items: items.map((it) => ({
          id: Number(it.v),
          quantity: it.q || 1,
          properties: { [this.dataset.propKey]: this.dataset.propValue, _kutu_id: kutuId },
        })),
        sections: Cart.sections,
      };
      await Cart.addItems(
        { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) },
        button, // truthy → tema cart drawer'ı otomatik açar
      );
      // ekleme-sonrası doğrulama — KENDİ try'ında: verify hatası ≠ ekleme hatası (çift-adet önlemi)
      let verified = null;
      try { verified = await this.cartLines(kutuId); } catch { verified = null; }
      if (verified && verified.count < items.length) {
        if (verified.count === 0) {
          // 200 döndü ama sepette iz yok: seçim aynen duruyor, jenerik hata
          this.showTransient(this.i18n.error || '', true);
          feedback('box--error');
          return;
        }
        // kısmi ekleme: girenleri geri al (seçim tam kalır) ya da geri-alma düşerse sticky-partial
        await this.resolvePriorLines(items, verified);
        return;
      }
      // başarı (tam doğrulandı ya da doğrulama ulaşamadı → ekleme 200 ise başarı say)
      items.forEach((it) => BoxStore.remove(it.v, it.c)); // yalnız GÖNDERİLEN kalemler (uçuş-anı seçimleri korunur)
      boxIdSig = null;
      this.postSuccess = true;
      this.showTransient(this.i18n.success || '', false); // aria-live → SR duyurusu (toast YOK: drawer'ın açılması yeterli)
    } catch (err) {
      console.warn('[box-builder] sepete ekleme hatası:', err);
      // hata yolu: ÖNCE sepete ne girdiğini çözümle (girenler dururken tükendi-değiştir-tekrar akışı
      // mükerrer eklerdi); sepette iz yoksa sebebi (tükendi/jenerik) göster
      let prior = null;
      try { prior = kutuId ? await this.cartLines(kutuId) : { count: 0, variants: new Set(), keys: [] }; } catch { prior = null; }
      if (!(await this.resolvePriorLines(items, prior))) {
        try { await this.preValidate(items); } catch { /* yoksay */ }
        if (items.some((it) => soldOut.has(String(it.v)))) {
          this.render(); // error_stock durumu + slot rozetleri devrede
          if (window.matchMedia(MOBILE_MQ).matches) this.setExpanded(true);
        } else {
          this.showTransient(this.i18n.error || '', true);
          feedback('box--error');
        }
      }
    } finally {
      inFlight = false;
      button.removeAttribute('aria-busy');
      if (labelEl) labelEl.textContent = oldLabel;
      this.render();
    }
  }
}

/* ── kayıt + global senkron ────────────────────────────────────────────── */
customElements.get('box-toggle') || customElements.define('box-toggle', BoxToggle);
customElements.get('box-checkbox') || customElements.define('box-checkbox', BoxCheckbox);
customElements.get('box-bar') || customElements.define('box-bar', BoxBar);

applyBodyClass();
window.addEventListener('pageshow', (e) => { if (e.persisted) syncAll(); }); // bfcache: connectedCallback çalışmaz
document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') syncAll(); });
